import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/hooks/trpc";
import { HarvestCleaningPositionEnum } from "@brewbase/db/types";
import { SessionModelCleaningSection } from "@/features/harvest-journal/components/session-model-cleaning-section";
import { JournalPage } from "@/features/harvest-journal/components/journal-page";

export const Route = createFileRoute("/harvests/$session_id/post-cleaning")({
  component: RouteComponent,
});

function RouteComponent() {
  const { session_id } = Route.useParams();
  const { data: session } = trpc.harvest.getSession.useQuery(session_id);

  return (
    <JournalPage>
      <SessionModelCleaningSection
        sessionId={session_id}
        position={HarvestCleaningPositionEnum.POST}
        isEditable={!session?.ended_at}
      />
    </JournalPage>
  );
}
